<template>
    <div>
        <div class="sheet-section-label">{{ label }}</div>
        <div class="sheet-group"><slot /></div>
    </div>
</template>

<script>
export default {
    name: 'SheetSection',
    props: ['label'],
};
</script>
